// src/propertyManagement/pages/PMPaymentComplete.jsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs
} from 'firebase/firestore';

export default function PMPaymentComplete() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { jobId, paymentAmount, vendorName, fee } = state || {};

  const handleDownloadReceipt = async () => {
    try {
      const filesCol = collection(db, 'workOrders', jobId, 'files');
      const filesQuery = query(
        filesCol,
        where('type', '==', 'receipt'),
        orderBy('createdAt', 'desc'),
        limit(1)
      );
      const snap = await getDocs(filesQuery);
      if (!snap.empty) {
        const fileData = snap.docs[0].data();
        const url = fileData.url;
        const name = fileData.name;
        const res = await fetch(url);
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }
    } catch (err) {
      console.error('Error downloading receipt:', err);
    }
  };
  const netAmount = paymentAmount - fee;

  return (
    <Box sx={{ textAlign: 'center', mt: 8 }}>
      <Typography variant="h4" gutterBottom>
        Payment completed!
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 4 }}>
        ${netAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })} has been sent to {vendorName || 'the contractor'}.
       </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/pm/maintenance/vendors')}
        >
          Back to Vendors
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleDownloadReceipt}
        >
          Download Receipt
        </Button>
      </Box>
    </Box>
  );
}
